import { IDealerResourceCategoryConfig, IDealerResourcesConfig } from '../../../../_shared/models/models-index';

export class DealerResourcesConfig implements IDealerResourcesConfig {
  public disclaimer: string;
  public reportTitle: string;
  public resourceCategories: IDealerResourceCategoryConfig[];
}
